"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.STAGING_DOMAINS = exports.STAGING_STORES = void 0;

/* eslint-disable no-template-curly-in-string */
// Staging Stores
var s1 = {
  label: 'United Kingdom',
  currency: 'GBP',
  currencyFormat: '£{{amount}}',
  storeCode: 's1',
  liveStoreCode: 'gb',
  language: 'en',
  locale: 'en',
  domain: 'https://staging1.gymshark.com'
};
var s2 = {
  label: 'Deutschland & Österreich',
  currency: 'EUR',
  currencyFormat: '€{{amount}}',
  storeCode: 's2',
  liveStoreCode: 'de',
  language: 'de',
  locale: 'de',
  domain: 'https://staging2.gymshark.com'
};
var s3 = {
  label: 'France',
  currency: 'AUD',
  currencyFormat: '${{amount}}',
  storeCode: 's3',
  liveStoreCode: 'fr',
  language: 'fr',
  locale: 'fr',
  domain: 'https://staging3.gymshark.com'
};
var s4 = {
  label: 'Nederlands',
  currency: 'CAD',
  currencyFormat: '${{amount}}',
  storeCode: 's4',
  liveStoreCode: 'nl',
  language: 'nl',
  locale: 'nl',
  domain: 'https://staging4.gymshark.com'
}; // Live Stores

var STORES = {
  au: {
    label: 'Australia and New Zealand',
    currency: 'AUD',
    currencyFormat: '${{amount}} AUD',
    storeCode: 'au',
    liveStoreCode: 'au',
    language: 'en',
    locale: 'en-AU',
    domain: 'https://au.gymshark.com'
  },
  ca: {
    label: 'Canada',
    currency: 'CAD',
    currencyFormat: '${{amount}} CAD',
    storeCode: 'ca',
    liveStoreCode: 'ca',
    language: 'en',
    locale: 'en-CA',
    domain: 'https://ca.gymshark.com'
  },
  dk: {
    label: 'Danmark',
    currency: 'DKK',
    currencyFormat: '{{amount}} DKK',
    storeCode: 'dk',
    liveStoreCode: 'dk',
    language: 'en',
    locale: 'da-DK',
    domain: 'https://dk.gymshark.com'
  },
  fi: {
    label: 'Finland',
    currency: 'EUR',
    currencyFormat: '{{amount}}€',
    storeCode: 'fi',
    liveStoreCode: 'fi',
    language: 'en',
    locale: 'fi-FI',
    domain: 'https://fi.gymshark.com'
  },
  fr: {
    label: 'France',
    currency: 'EUR',
    currencyFormat: '{{amount}}€',
    storeCode: 'fr',
    liveStoreCode: 'fr',
    language: 'fr',
    locale: 'fr-FR',
    domain: 'https://fr.gymshark.com'
  },
  de: {
    label: 'Deutschland & Österreich',
    currency: 'EUR',
    currencyFormat: '{{amount}}€',
    storeCode: 'de',
    liveStoreCode: 'de',
    language: 'de',
    locale: 'de',
    domain: 'https://de.gymshark.com'
  },
  ie: {
    label: 'Republic of Ireland',
    currency: 'EUR',
    currencyFormat: '{{amount}}€',
    storeCode: 'ie',
    liveStoreCode: 'ie',
    language: 'en',
    locale: 'ga-IE',
    domain: 'https://ie.gymshark.com'
  },
  nl: {
    label: 'Nederlands',
    currency: 'EUR',
    currencyFormat: '€{{amount}}',
    storeCode: 'nl',
    liveStoreCode: 'nl',
    language: 'nl',
    locale: 'nl',
    domain: 'https://nl.gymshark.com'
  },
  no: {
    label: 'Norge',
    currency: 'NOK',
    currencyFormat: '{{amount}} NOK',
    storeCode: 'no',
    liveStoreCode: 'no',
    language: 'en',
    locale: 'nb-NO',
    domain: 'https://no.gymshark.com'
  },
  se: {
    label: 'Sverige',
    currency: 'SEK',
    currencyFormat: '{{amount}} SEK',
    storeCode: 'se',
    liveStoreCode: 'se',
    language: 'en',
    locale: 'sv-SE',
    domain: 'https://se.gymshark.com'
  },
  ch: {
    label: 'Schweiz',
    currency: 'CHF',
    currencyFormat: '{{amount}} CHF',
    storeCode: 'ch',
    liveStoreCode: 'ch',
    language: 'gsw-CH',
    locale: 'de',
    domain: 'https://ch.gymshark.com'
  },
  gb: {
    label: 'United Kingdom',
    currency: 'GBP',
    currencyFormat: '£{{amount}}',
    storeCode: 'gb',
    liveStoreCode: 'gb',
    language: 'en',
    locale: 'en-GB',
    domain: 'https://uk.gymshark.com'
  },
  us: {
    label: 'United States',
    currency: 'USD',
    currencyFormat: '${{amount}} USD',
    storeCode: 'us',
    liveStoreCode: 'us',
    language: 'en',
    locale: 'en-US',
    domain: 'https://www.gymshark.com'
  },
  eu: {
    label: 'Europe',
    currency: 'EUR',
    currencyFormat: '{{amount}}€',
    storeCode: 'eu',
    liveStoreCode: 'eu',
    language: 'en',
    locale: 'en-EU',
    domain: 'https://eu.gymshark.com'
  },
  rw: {
    label: 'Rest of World',
    currency: 'USD',
    currencyFormat: '${{amount}} USD',
    storeCode: 'rw',
    liveStoreCode: 'rw',
    language: 'en',
    locale: 'en',
    domain: 'https://row.gymshark.com'
  }
};
var STAGING_STORES = {
  s1: s1,
  s2: s2,
  s3: s3,
  s4: s4,
  xd: {
    label: 'United States',
    currency: 'USD',
    currencyFormat: '${{amount}}',
    storeCode: 'xd',
    liveStoreCode: 'us',
    language: 'en',
    locale: 'en-US',
    domain: 'https://dev.gymshark.com'
  },
  xs: s1,
  xs2: s2,
  xs3: s3,
  xs4: s4
};
exports.STAGING_STORES = STAGING_STORES;
var STAGING_DOMAINS = ['https://staging1.gymshark.com', 'https://staging2.gymshark.com', 'https://staging3.gymshark.com', 'https://staging4.gymshark.com', 'https://dev.gymshark.com'];
exports.STAGING_DOMAINS = STAGING_DOMAINS;
var _default = STORES;
exports["default"] = _default;